// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__24xPR","itemTitle":"ClientEmergencyInfo_itemTitle__1alYY","itemText":"ClientEmergencyInfo_itemText__XkvDT"};